import React from 'react'
import PropTypes from 'prop-types'

import './MenuItem.css'

export const MenuItem = ({
  description,
  calories,
  imageUrl
}) => {
  return (
    <React.Fragment>
      <p data-testid='modifier-item-description' styleName='description'>{description}</p>
      {calories > 0 && <p data-testid='modifier-item-calories' styleName='calories'>{calories} Calories</p>}
      {imageUrl && (
        <div
          data-testid='modifier-image-url'
          styleName='image'
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}
    </React.Fragment>
  )
}

MenuItem.propTypes = {
  description: PropTypes.string,
  calories: PropTypes.number,
  imageUrl: PropTypes.string
}
